import {
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_MONTHLY_SCAN_STATS_REQUEST,
  GET_MONTHLY_SCAN_STATS_SUCCESS,
  GET_MONTHLY_SCAN_STATS_FAILURE
} from '../../constants/dashboardConstant/dashboardConstants';

export const getDashboardStatsRequest = (oemId, month) => ({
  type: GET_DASHBOARD_STATS_REQUEST,
  payload: { oemId, month }
});

export const getDashboardStatsSuccess = (data) => ({
  type: GET_DASHBOARD_STATS_SUCCESS,
  payload: data
});

export const getDashboardStatsFailure = (error) => ({
  type: GET_DASHBOARD_STATS_FAILURE,
  payload: error
});

export const getMonthlyScanStatsRequest = (oemId) => ({
  type: GET_MONTHLY_SCAN_STATS_REQUEST,
  payload: oemId
});

export const getMonthlyScanStatsSuccess = (data) => ({
  type: GET_MONTHLY_SCAN_STATS_SUCCESS,
  payload: data
});

export const getMonthlyScanStatsFailure = (error) => ({
  type: GET_MONTHLY_SCAN_STATS_FAILURE,
  payload: error
});